import { useEffect } from 'react';
import { ADDITIONAL_MEDIA_ID_PREFIX } from '../constants';
import { hasWindow } from '../../utils/browser';
/** Checks and attempts to extract an index from window.location.hash and
 *  then calls `whenFound` on the `PapiAttachmentFile` at that index */ export function useMultiArtDeepLinking(additionalMedia, whenFound) {
    // skip to hash fragment (if any) in the url for deeplinking
    useEffect(()=>{
        // slice past '#'
        const hash = window.location.hash.slice(1);
        if (!hasWindow() || !hash.startsWith(ADDITIONAL_MEDIA_ID_PREFIX)) {
            return;
        }
        const hashIdIndexString = window.location.hash.slice(1).replace(ADDITIONAL_MEDIA_ID_PREFIX, '');
        const hashIdIndex = Number.parseInt(hashIdIndexString, 10);
        if (!Number.isSafeInteger(hashIdIndex) || hashIdIndex < 0) {
            return;
        }
        if (additionalMedia === null || additionalMedia === void 0 ? void 0 : additionalMedia[hashIdIndex]) {
            whenFound(additionalMedia === null || additionalMedia === void 0 ? void 0 : additionalMedia[hashIdIndex]);
        }
    }, [
        additionalMedia,
        whenFound
    ]);
}

//# sourceMappingURL=useMultiArtDeepLinking.js.map